import React from 'react';
import PropTypes from 'prop-types';
import cn from '../../../utils/cn';
import styles from './CloseButton.module.scss';

export default function CloseButton({ centeredStyle, closeToast }) {
  return (
    <button
      aria-label="Close popup"
      className={cn(styles.close, { [styles.centered]: centeredStyle })}
      type="button"
      onClick={closeToast}
    >
      ✕
    </button>
  );
}

CloseButton.propTypes = {
  centeredStyle: PropTypes.bool,
  closeToast: PropTypes.func
};

CloseButton.defaultProps = {
  centeredStyle: false,
  closeToast: null
};
